module.exports = __webpack_public_path__ + "static/media/scanner-production.f13d8bc8.apk";